// extracted by mini-css-extract-plugin
module.exports = {"button":"ButtonComponent_button__13wbm","outlineButton":"ButtonComponent_outlineButton__3uNOS","mdSizeButton":"ButtonComponent_mdSizeButton__1eDtx"};